const emailReg = /[^@]+@[^.]+\..+/

export const filterEmails = emails =>
  emails.filter(entry => emailReg.test(entry))

export const convertTextToEmails = text => filterEmails(text.split(/[ ,;]+/))
